export const normalizeStatus = (status) => {
    switch (status) {
        case  'ASSEMBLED' : return "Złożono";
        case  'ASSIGNED' : return "Przypisano";
        case  'NEW' : return "Nowy";
        default: return status;
    }
}